const BASE = 'https://dev-api.knostos.com/';
export const environment = {
  production: false,
  authTokenKey: 'accessToken',
  qvToken: 'qv_token',
  qvSharedToken: 'qv_shared_token',
  qvAppId: 'qvAppId',
  qvUserId: 'qvUserId',
  dashboardQvPageId: 'fnHqNYggG',
  measurementSystem: 'measurementSystem',
  GLEAP_API_KEY: '1tipB4NNG1vPVPQJwCBoyY7yg8r5sle1',
  QRVEY_DOMAIN: 'https://ykrii.qrveyapp.com',
  USER_BASE: `${BASE}user-management`,
  LEGACIES: 'https://4n9hptxz1a.execute-api.us-east-2.amazonaws.com/dev',
  // currently not use
  PAYMENT_MANAGEMENT_BASE: `${BASE}payment_management`,
  TRACKER_BASE: `${BASE}tracker`,
  MED_REVIEW_BASE: `${BASE}med-review`,
  TIMELINE_BASE: `${BASE}timeline`,
  CORE_BASE: `${BASE}core`,
  EVENT_BASE: `${BASE}event`,
  FOLLOWUP_BASE: `${BASE}follow-up`,
  ME_BASE: `${BASE}me`,
  DRP_BASE: `${BASE}drp`,
  ACTIVITY_TRACKING_BASE: `${BASE}activity`,
  STATEMENTS_COLLECTIONS_BASE: `${BASE}statement`,
  MOBILE_BASE: `${BASE}mobile-gateway`,
  NOTIFICATION_BASE: `${BASE}notification`,
  COMPLIANCE_BASE: `${BASE}compliance`,
  PROCESS_NAVIGATOR_BASE: `${BASE}process-navigator`,
  FORMS_CONCEPTS_BASE: `${BASE}forms-concepts`,
  QRVEY_ACCESS_MANAGER: `${BASE}qrvey-access-manager`,
  AGREEMENT_BASE: `${BASE}agreement`,
  BRIDGEPAY_BASE: `${BASE}bridgepay`,
  BRIDGEPAY_API_KEY: 'bp_dev_2c65ba37195386bb9a3ae1ff7a22773dd16180be50f0d1229a137556568257c2',
  USERNAME_FOR_LOCAL_NETWORK_COMMUNICATION: 'knostos',
  PASSWORD_FOR_LOCAL_NETWORK_COMMUNICATION: '6\\?6uqtu@ZTW@KC!rVj8L,xv0',
  MEDPLUS_AUTH_URL: 'https://api.medplus.co/oauth2/token',
  API_KEY: 'AIzaSyCOV7tovzfW7HnMql2k8s3RgmTa-wC2i5Y',
  WEBSOCKET_URL: `https://notification.dev-api.knostos.com/ws`,
  PREFIX_MEDREVIEW_PV1_IMAGES: 'https://ips-images.medpluspr.com:5443/docs/patient_documents/',
  LUNCHDARKLY_SDK_KEY: '66efe25c4eb8ad104ec76310',
  LAUNCHDARKLY_RELAY_URL: 'https://relay-proxy.dev-api.knostos.com',
  TWIXOR_BASE: 'https://engagedev.knostos.com/chatagent?authToken=',
  ENGAGE_BASE: 'https://engagedev.knostos.com/',
  AI_GATEWAY_BASE: `${BASE}ai-service`,
};
